import { render, staticRenderFns } from "./WaitConfirm.vue?vue&type=template&id=4461e846"
import script from "./WaitConfirm.vue?vue&type=script&lang=js"
export * from "./WaitConfirm.vue?vue&type=script&lang=js"
import style0 from "./WaitConfirm.vue?vue&type=style&index=0&id=4461e846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports